export default function WorkProcess() {
  const steps = [
    {
      number: '1',
      title: 'Du stellst den Kontakt her',
      description: 'über Social Media, dein Netzwerk oder persönliche Empfehlungen.',
      icon: 'ri-user-add-line'
    },
    {
      number: '2',
      title: 'Die Gespräche laufen gemeinsam',
      description: 'wir präsentieren das Modell im 3er-Zoom: Du, dein Interessent und ein erfahrener Partner.',
      icon: 'ri-video-chat-line'
    },
    {
      number: '3',
      title: 'Du lernst automatisch mit',
      description: 'nach wenigen Gesprächen fühlst du dich sicher.',
      icon: 'ri-graduation-cap-line'
    },
    {
      number: '4',
      title: 'Wir geben dir alles an die Hand',
      description: 'Einarbeitung, Skripte, Vorlagen, Videos, tägliche Unterstützung.',
      icon: 'ri-folder-open-line'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 text-center">
            Einfacher Einstieg, klarer Prozess
          </h2>
          <p className="text-2xl text-gray-700 mb-16 text-center">
            ohne etwas selbst „verkaufen" zu müssen
          </p>

          <div className="bg-blue-50 p-8 rounded-2xl mb-12">
            <p className="text-xl text-gray-800 text-center leading-relaxed">
              Bei uns musst du keine Präsentationen halten und nichts verkaufen.
              Du arbeitest im Team und wirst von Anfang an begleitet.
            </p>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-10 text-center">
            So läuft es ab:
          </h3>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="absolute -top-4 -left-4 w-12 h-12 flex items-center justify-center bg-blue-600 text-white text-2xl font-bold rounded-full shadow-lg">
                  {step.number}
                </div>
                <div className="flex items-start gap-4 mt-2">
                  <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                    <i className={`${step.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-10 rounded-2xl text-center">
            <p className="text-2xl font-bold mb-2 flex items-center justify-center gap-3">
              <span className="text-3xl">🧩</span>
              <span>Deine Hauptaufgabe: Menschen zu verbinden.</span>
            </p>
            <p className="text-xl">
              Den Rest übernehmen wir gemeinsam im Team.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
